module.exports = __webpack_public_path__ + "static/media/login-illustration.b90e48f0.svg";